import { put, takeLatest } from "redux-saga/effects";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "common/components/apiConfig";

export const actionTypes = {
  selectSavingTransactions: "[selectSavingTransactions] Action",
  selectSavingTransactionsLoading: "[selectSavingTransactionsLoading] Action",
  selectSavingTransactionsAsync: "[selectSavingTransactionsAsync] Action",
};

const initialState = {
  data: [],
  size: 100,
  total: 10000,
  loading: false,
};

export const select_saving_transactions_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectSavingTransactions:
      return {
        ...state,
        data: payload.results,
        total: payload.total
          ? payload.total > 10000
            ? 10000
            : payload.total
          : 0,
      };
    case actionTypes.selectSavingTransactionsLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  let config = {
    url: "select_request",
  };

  let data = {
    table: "direct_debit",
    method_type: "select_saving_transactions",
    data: payload.data ? payload.data : {},
    from: payload.from ? (payload.from - 1) * payload.size : 0,
    size: payload.size,
    sort_by: payload.sort_by,
  };

  yield put({
    type: actionTypes.selectSavingTransactionsLoading,
    payload: true,
  });

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);

    if (!isOk) return;
    yield put({
      type: actionTypes.selectSavingTransactions,
      payload: res.data.response.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectSavingTransactionsLoading,
      payload: false,
    });
  }
}

export function* selectSavingTransactions() {
  yield takeLatest(actionTypes.selectSavingTransactionsAsync, handleWorker);
}
